<style lang="scss" scoped>
.legend {
  text-align: right;

  .header {
    margin-bottom: 10px;
    color: $c-dark-blue;
    font-size: 20px;
  }
  .barcontainer {
    margin-top: 10px;

    svg {
      fill: $c-blue;
    }
    .bar {
      height: 6px;

      &.high {
        background-color: $c-dark-blue;
      }
      &.medium {
        background-color: $c-medium-blue;
      }
      &.low {
        background-color: $c-light-blue;
      }
      &.historical {
        border: 1px solid $c-dark-grey;
        border-radius: 3px;
      }

      &.none {
        background-color: #fff;
      }
    }
  }

  .targetcontainer {
    margin-top: 35px;
    display: flex;
    align-items: center;
    justify-content: flex-end;

    .text {
      margin-right: 15px;
    }
    .bar {
      height: 30px;
      width: 2px;
      background-color: #000;
    }
  }
}

.legend.horizontal {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 20px;

  padding: 0px 10px 0px 10px;

  //border:1px solid red;
  // border:1px solid $c-dark-grey;

  .header {
    width: 100%;
    text-align: left;
    font-size: 24px;
    display: none;
  }

  .barcontainer,
  .targetcontainer {
    margin: 10px 5px;
    padding: 10px 3px 8px 3px;
    flex-grow: 1;
    text-align: center;
    color: #fff;
    font-size: 13px;
    letter-spacing: 1px;
  }

  .bar-high-bg {
    background-color: $c-high-competence;
  }
  .bar-medium-bg {
    background-color: $c-medium-competence;
  }
  .bar-low-bg {
    background-color: $c-low-competence;
    color: $c-dark-grey;
  }
  .none-bar-bg {
    color: $c-dark-grey;
    background-color: $c-no-competence;
  }
  .histrocial-bar-bg {
    border: 1px solid $c-dark-grey;

    color: $c-dark-grey;
  }
  .strategic-bar {
    color: $c-dark-grey;
  }
  .zielwert {
    color: $c-dark-grey;
    border-right: 2px solid #000;
  }

  .bar {
    display: none;
  }
}
</style>

<template>
  <div class="legend-outer">
    <h3>{{ $t('legend.title') }}</h3>
    <div class="legend" :class="{ horizontal }">
      <div class="header" v-if="!noheader">{{ $t('legend.title') }}</div>
      <div class="barcontainer bar-high-bg">
        <div class="text">{{ $t('legend.high') }}</div>
        <div class="high bar"></div>
      </div>
      <div class="barcontainer bar-medium-bg">
        <div class="text">{{ $t('legend.medium') }}</div>
        <div class="medium bar"></div>
      </div>
      <div class="barcontainer bar-low-bg">
        <div class="text">{{ $t('legend.low') }}</div>
        <div class="low bar"></div>
      </div>
      <div class="barcontainer none-bar-bg" v-if="!withTarget">
        <div class="text">{{ $t('legend.none') }}</div>
        <div class="none bar"></div>
      </div>
      <div class="barcontainer histrocial-bar-bg" v-if="withTarget">
        <div class="text">{{ $t('legend.historic') }}</div>
        <div class="historical bar"></div>
      </div>

      <div class="barcontainer strategic-bar">
        <div class="text">{{ $t('legend.strategic') }} <Icon :path="mdiStar" :width="25" :height="25" /></div>
      </div>
      <div class="barcontainer strategic-bar">
        <div class="text">{{ $t('legend.future') }} <Icon :path="mdiDiamond" :width="25" :height="25" /></div>
      </div>
      <div class="barcontainer strategic-bar">
        <div class="text">{{ $t('legend.leadership') }} <Icon :path="mdiCrown" :width="25" :height="25" /></div>
      </div>

      <div class="targetcontainer zielwert" v-if="withTarget">
        <div class="text">{{ $t('legend.target') }}</div>
        <div class="bar"></div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mdiStar, mdiDiamond, mdiCrown } from '@mdi/js';

export default defineComponent({
  props: {
    withTarget: { type: Boolean, default: false },
    noheader: { type: Boolean, default: false },
    horizontal: { type: Boolean, default: false },
  },
  setup() {
    return {
      mdiStar,
      mdiCrown,
      mdiDiamond,
    };
  },
});
</script>
